(function (app) {
  app.printer = (props) => {
    const storage = window.localStorage;
    const printer = JSON.parse(storage.getItem('printer') || '{}');
    const valid_keys = ['a4', 'label'];
    if (props === undefined) {
      const output = valid_keys.map(key => {
        return `${key[0].toUpperCase() + key.slice(1)} printer: ${printer[key] ? printer[key].id : 'Not set'}`;
      }).join('\n');
      console.log(output);
      return 'Done';
    }
    if (!(props instanceof Object)) {
      valid_keys.forEach(key => delete printer[key]);
      storage.setItem('printer', JSON.stringify(printer));
      console.log('All printers removed');
      return 'Done';
    }
    for (let key in props) {
      const type = key;
      key = type.toLowerCase();
      if (valid_keys.includes(key)) {
        const value = printer[key];
        if (!props[key]) {
          delete printer[key];
        } else {
          printer[key] = { id: props[key] };
        }
        const type = key[0].toUpperCase() + key.slice(1);
        console.log(type + ' printer: ' + (!props[key] ? !value ? 'Not set' : 'Removed' : props[key]));
      } else {
        console.error('Unknown printer type: ' + type);
      }
    }
    storage.setItem('printer', JSON.stringify(printer));
    return 'Done';
    // Example: printer({ a4: 75116522, label: 70947588 })
  }
  app.station = (string) => {
    const storage = window.localStorage;
    const printer = JSON.parse(storage.getItem('printer') || '{}');
    if (string === undefined) {
      console.log(`Station: ${printer.station ? printer.station : 'Not set'}`);
      return 'Done';
    }
    if (typeof string !== 'string') {
      delete printer.station;
      storage.setItem('printer', JSON.stringify(printer));
      console.log('Station: Removed');
      return 'Done';
    }
    printer.station = string.replace(/\s+/g, ' ').trim();
    if (!printer.station) {
      delete printer.station;
    }
    storage.setItem('printer', JSON.stringify(printer));
    console.log(`Station: ${printer.station ? printer.station : 'Removed'}`);
    return 'Done';
    // Example: station('Station 1')
  }
})(window);